import React from 'react'
import { Redirect } from 'react-router'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Routes } from '../constants'
import { EstateUtils } from '../utils'

const {LANDING: INITIAL_ROUTE } = Routes

/**
 * Get estate form url param
 * @param {Object} props Private route props
 */
function getUrlEstate(props) {
    const { match } = props
    const { params } = match || {}
    const { estate } = params || {}
    return estate || ''
}

/**
 * Get default estate. The default estate is the one with lowest order number
 * @param {Array} estates
 */
function getDefaultEstate(estates) {
    /**
     * Function to sort estates by ordering number
     * @param {Object} estate1
     * @param {Object} estate2
     */
    const estateSort = (estate1 = {}, estate2 = {}) => {
        const { order: o1 } = estate1
        const { order: o2 } = estate2
        return o1 - o2
    }

    // Sort the list and take the id of the first one
    const { id } = estates.sort(estateSort)[0] || {}
    return id || ''
}

/**
 * Root page component
 * @param {Object} props
 */
function RootPage(props) {
    const { estates } = props
    const urlEstate = getUrlEstate(props)
    const estate = urlEstate && EstateUtils.isValidEstate(urlEstate) ? urlEstate : getDefaultEstate(estates)
    const routeToRedirectTo = Routes.buildRoute(INITIAL_ROUTE, { estate })

    return <Redirect to={routeToRedirectTo} />
}

RootPage.propTypes = {
    estates: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, order: PropTypes.number })).isRequired,
}

const mapStateToProps = ({ app: { estates } }) => ({
    estates,
})

export default connect(mapStateToProps, null)(RootPage)
